/* wc-pdp-guards.js
   ------------------------------------------------------------------
   WC — PDP guards (global + search-scoped)
   This version is SAFE for collection/direct arrivals.

   What this file does:
   A) GLOBAL (always on)
      - Hide single-value controls ONLY for whitelisted option names (e.g., Surface)
      - No-flash variant cloak: hide variant UI for ~1-2 frames until correct selection is set
      - Early URL sync: apply ?variant= / ?model= immediately (before theme scripts finish)
   B) SEARCH-ONLY (handle-scoped)
      - Prevent theme auto-preselect on first paint (CE patch + placeholder on first option)
      - Clear hidden variant id while no real user pick happened
      - Auto-disable if product is single-variant OR initial variant already selected

   Load order:
   - Defer near end of product template (after JSON blobs).
   - Early marker (wc-productsearch-guards.js) may set sessionStorage.wcSearchArrival.
   ------------------------------------------------------------------ */

/* =========================
   A + B) MAX SHIELD (LIGHT)
   ========================= */
(function(){
  var root = document.getElementById('wc-product-root') || document.querySelector('[data-section-type="product"]');
  if (!root || root.getAttribute('data-is-full-product') !== 'true') return;

  /* --- Config --- */
  // Only these option names (lowercase) will be auto-hidden when they have a single real value:
  var HIDE_SINGLE_VALUE_OPTION_NAMES = ['surface'];
  var PLACEHOLDER_TEXT = 'Please select';

  /* --- Helpers --- */
  function q(s, c){ return (c||document).querySelector(s); }
  function qa(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }

  // Extract option name from element (select/fieldset)
  function optionNameOf(el){
    if (!el) return '';
    // select: prefer data-name rendered by Liquid
    var n = (el.getAttribute && (el.getAttribute('data-name') || '')) || '';
    if (!n && el.name) {
      var m = el.name.match(/^options\[(.+)\]$/i);
      if (m) n = m[1];
    }
    if (!n) {
      // try fieldset group
      n = (el.getAttribute && (el.getAttribute('data-option-name') || el.getAttribute('data-option-position') || el.getAttribute('data-option-index') || '')) || '';
    }
    return (n + '').toLowerCase().trim();
  }

  // read Product JSON once to know if the product has a single variant
  function isSingleVariantProduct(){
    try{
      var el = q('script[id^="ProductJson-"]', root);
      if (!el || !el.textContent) return false;
      var obj = JSON.parse(el.textContent);
      return !!(obj && obj.variants && obj.variants.length <= 1);
    }catch(_){ return false; }
  }

  // read current hidden/select/radio id state
  function hasInitialVariantSelected(){
    var form = q('form[action*="/cart/add"]', root) || q('product-form form', root);
    if (!form) return false;
    var hid = form.querySelector('input[type="hidden"][name="id"]');
    if (hid && (hid.value||'').trim()) return true;
    var sel = form.querySelector('select[name="id"]');
    if (sel && (sel.value||'').trim()) return true;
    var rad = form.querySelector('input[type="radio"][name="id"]:checked');
    return !!rad;
  }

  // Search-arrival flag bound to this product handle
  function fromSearch(){
    try{
      var raw = sessionStorage.getItem('wcSearchArrival');
      if (!raw) return false;
      var obj = JSON.parse(raw);
      var current =
        (root.getAttribute('data-prod-handle')) ||
        (location.pathname.match(/\/products\/([^\/?#]+)/)||[])[1] || '';
      return !!(obj && obj.h === current);
    }catch(_){ return false; }
  }
  function guardOn(){ return !!(window.__WC_NO_PRESELECT || fromSearch()); }

  // If single-variant OR already selected on load → don't guard at all.
  if (isSingleVariantProduct() || hasInitialVariantSelected()){
    window.__WC_USER_PICKED = true;
    window.__WC_NO_PRESELECT = false;
  }

  /* --- No-flash cloak + early URL sync (global) --- */
  function ensureNoFlashStyle(){
    if (document.getElementById('wc-noflash-style')) return;
    const s = document.createElement('style');
    s.id = 'wc-noflash-style';
    s.textContent = `
[data-wc-cloak="1"] .product__selectors,
[data-wc-cloak="1"] .product-form__variants,
[data-wc-cloak="1"] .product__info .product-options,
[data-wc-cloak="1"] .product-form,
[data-wc-cloak="1"] #wc-case-switcher{
  visibility: hidden !important;
}
`;
    document.head.appendChild(s);
  }
  function findPdpRoot(){ return root || document.getElementById('wc-product-root') || document.body; }
  function cloakPickers(on){
    try{
      const host = findPdpRoot();
      if (!host) return;
      if (on) host.setAttribute('data-wc-cloak','1');
      else host.removeAttribute('data-wc-cloak');
    }catch(_){}
  }
  function uncloakSoon(){
    // release after two frames to ensure theme scripts applied
    requestAnimationFrame(()=>requestAnimationFrame(()=>cloakPickers(false)));
    // hard failsafe
    setTimeout(()=>cloakPickers(false), 1500);
  }

  // Label → keys (generic, not only for iPhone)
  function toKeys(label){
    if (!label) return [];
    let s = String(label).replace(/&amp;/g,'&').replace(/&#x2F;/g,'/').toLowerCase().trim();
    s = s.replace(/\s+and\s+/g,'/').replace(/[,&]+/g,'/').replace(/\bcase(s)?\b/g,'').replace(/\s{2,}/g,' ').trim();
    const parts = s.split('/').map(p=>p.trim()).filter(Boolean);
    const keys = parts.map(p => p.replace(/[^\w ]+/g,'').replace(/\s+/g,'-'));
    return Array.from(new Set(keys));
  }

  // Apply ?variant=123 ASAP (before theme fully initializes)
  function earlyVariantFromUrl(){
    try{
      const u = new URL(location.href);
      const vid = u.searchParams.get('variant');
      if (!vid) return false;
      const idInput = (root || document).querySelector('form[action*="/cart/add"] [name="id"], input[name="id"]');
      if (!idInput) return false;
      if (String(idInput.value||'') === String(vid)) return true;
      idInput.value = String(vid);
      idInput.dispatchEvent(new Event('input',{bubbles:true}));
      idInput.dispatchEvent(new Event('change',{bubbles:true}));
      document.dispatchEvent(new CustomEvent('variant:change',{detail:{variantId:String(vid)}}));
      return true;
    }catch(_){ return false; }
  }

  // Apply ?model=slug by matching select option labels ASAP
  function earlyModelFromUrl(){
    try{
      const u = new URL(location.href);
      const slug = (u.searchParams.get('model')||'').toLowerCase();
      if (!slug) return false;
      const sels = qa('select[name^="options["]', root || document);
      for (const sel of sels){
        const opts = Array.from(sel.options||[]);
        for (const o of opts){
          const keys = toKeys(o.text || o.value);
          if (keys.includes(slug)){
            if (sel.value !== o.value){
              sel.value = o.value;
              sel.dispatchEvent(new Event('change',{bubbles:true}));
            }
            return true;
          }
        }
      }
      return false;
    }catch(_){ return false; }
  }

  /* --- Patch Shopify custom elements to skip the theme’s first auto-select while guarded --- */
  (function patchCEs(tags){
    if (!('customElements' in window)) return;
    tags.forEach(function(tag){
      customElements.whenDefined(tag).then(function(){
        var C = customElements.get(tag);
        if (!C || C.prototype.__wc_patched) return;

        var orig = C.prototype.updateMasterId;
        if (typeof orig === 'function'){
          C.prototype.updateMasterId = function(){
            if (guardOn() && !window.__WC_USER_PICKED){
              // Keep hidden variant id empty until the user actually picks something
              var f = this.closest('form') || q('form[action*="/cart/add"]', root);
              var hid = f && f.querySelector('input[type="hidden"][name="id"]');
              if (hid){
                hid.value = '';
                hid.dispatchEvent(new Event('input', {bubbles:true}));
                hid.dispatchEvent(new Event('change', {bubbles:true}));
              }
              return; // block theme's auto-select on init
            }
            return orig.apply(this, arguments);
          };
        }

        var oc = C.prototype.connectedCallback;
        C.prototype.connectedCallback = function(){
          if (oc) oc.apply(this, arguments);
          // First real interaction unguards the flow
          this.addEventListener('change', function(){
            window.__WC_USER_PICKED = true;
            window.__WC_NO_PRESELECT = false;
          }, true);
        };

        C.prototype.__wc_patched = true;
      });
    });
  })([
    'variant-selects','variant-radios',
    'product-variant-selects','product-variant-radios',
    'variant-pills','variant-swatch','product-variants'
  ]);

  /* --- UI utilities --- */
  function hideIfSingleValue(el){
    var wrap = el.closest('.product-form__input') || el.closest('.selector-wrapper') || el.closest('[data-product-option]') || el.closest('fieldset') || el.parentElement;
    if (wrap && !wrap.hasAttribute('data-wc-collapsed')){
      wrap.setAttribute('data-wc-collapsed','1');
      wrap.style.display = 'none';
      if (el.id){
        var lab = root.querySelector('label[for="'+el.id+'"]');
        if (lab) lab.style.display = 'none';
      }
    }
  }

  // GLOBAL: hide single-value options ONLY if their name is whitelisted (e.g., "Surface")
  function hideSecondarySingles(){
    // selects
    qa('select[name^="options["]', root).forEach(function(sel){
      var optName = optionNameOf(sel);
      if (HIDE_SINGLE_VALUE_OPTION_NAMES.indexOf(optName) === -1) return; // not whitelisted → keep visible
      var real = qa('option', sel).filter(function(o){
        var v = (o.value||'').trim(), t = (o.text||'').trim();
        return v && !/please\s*select/i.test(t);
      });
      if (real.length <= 1) hideIfSingleValue(sel);
    });
    // radios (fieldset groups)
    qa('[data-option-position],fieldset[data-option-name],fieldset[data-option-index]', root).forEach(function(group){
      var optName = optionNameOf(group);
      if (HIDE_SINGLE_VALUE_OPTION_NAMES.indexOf(optName) === -1) return;
      var vals = Array.from(new Set(
        qa('input[type="radio"]', group)
          .filter(function(r){ return !r.disabled; })
          .map(function(r){ return r.value; })
      ));
      if (vals.length <= 1) hideIfSingleValue(group);
    });
  }

  // SEARCH ONLY: ensure first option shows placeholder and nothing is preselected
  function ensurePlaceholderFirst(){
    var changed = false;
    // First select (or any select) representing option1
    var firstSel = q('form[action*="/cart/add"] select[name^="options["]', root) || q('select[name^="options["]', root);
    if (firstSel){
      // If real options <= 1, don't force placeholder
      var real = Array.prototype.filter.call(firstSel.options || [], function(o){
        return (o.value||'').trim() !== '';
      });
      if (real.length <= 1) return false;
      
      // Normalize: make sure placeholder exists and is first
      var hasEmpty = false;
      for (var i=0;i<firstSel.options.length;i++){
        var o = firstSel.options[i];
        if ((o.value||'').trim() === '') hasEmpty = true;
        o.removeAttribute('selected');
      }
      if (!hasEmpty){
        var opt = document.createElement('option');
        opt.value = '';
        opt.textContent = PLACEHOLDER_TEXT;
        firstSel.insertBefore(opt, firstSel.firstChild);
      } else if (firstSel.options[0] && firstSel.options[0].value === ''){
        if (!/please\s*select/i.test(firstSel.options[0].text||'')){
          firstSel.options[0].text = PLACEHOLDER_TEXT;
        }
      }
      if (firstSel.value !== '') firstSel.value = '';
      firstSel.dispatchEvent(new Event('input',  {bubbles:true}));
      firstSel.dispatchEvent(new Event('change', {bubbles:true}));
      changed = true;
    } else {
      // Radio-based first group
      var firstGroup = q('[data-option-position],fieldset[data-option-name],fieldset[data-option-index]', root);
      if (firstGroup){
        qa('input[type="radio"]', firstGroup).forEach(function(r){
          if (r.checked){
            r.checked = false;
            r.removeAttribute('checked');
            r.dispatchEvent(new Event('change', {bubbles:true}));
          }
        });
        changed = true;
      }
    }
    return changed;
  }

  // SEARCH ONLY: clear hidden variant id to prevent implicit selection
  function clearHiddenId(){
    var form = q('form[action*="/cart/add"]', root) || q('product-form form', root);
    if (!form) return;
    var hid = form.querySelector('input[type="hidden"][name="id"]');
    if (hid && hid.value){
      hid.value = '';
      hid.dispatchEvent(new Event('input',  {bubbles:true}));
      hid.dispatchEvent(new Event('change', {bubbles:true}));
    }
  }

  // Idempotent apply
  function apply(){
    hideSecondarySingles(); // GLOBAL

    // SEARCH-ONLY guards
    if (!guardOn() || window.__WC_USER_PICKED) return;

    var forced = ensurePlaceholderFirst();
    if (forced) clearHiddenId();
  }

  // Debounced schedule
  var scheduled = false;
  function schedule(){
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function(){ scheduled = false; apply(); });
  }

  // Start: limited retries + safe observer; auto-stop after user interaction
  function start(){
    // --- GLOBAL no-flash start ---
    ensureNoFlashStyle();
    cloakPickers(true);

// Early URL sync (both supported)
let earlyApplied = false;
earlyApplied = earlyVariantFromUrl() || earlyApplied;
earlyApplied = earlyModelFromUrl()   || earlyApplied;

// If we successfully selected from URL, treat it as a real user pick.
// This prevents the search-only guards from forcing a placeholder after our selection.
if (earlyApplied) {
  window.__WC_USER_PICKED = true;
  window.__WC_NO_PRESELECT = false;
  try { sessionStorage.removeItem('wcSearchArrival'); } catch (_) {}
}


    // Release cloak on first stable variant signal OR fallback
    let released = false;
    function releaseOnce(){
      if (released) return;
      released = true;
      uncloakSoon();
    }
    document.addEventListener('variant:change', releaseOnce, { once:true });
    document.addEventListener('product:variant-change', releaseOnce, { once:true });

    // Also watch the ID input for changes to trigger release
    (function(){
      var form = q('form[action*="/cart/add"]', root) || q('product-form form', root);
      var idInput = form && form.querySelector('[name="id"]');
      if (idInput){
        try{
          var mo = new MutationObserver(releaseOnce);
          mo.observe(idInput, { attributes:true, attributeFilter:['value'] });
        }catch(_){}
        idInput.addEventListener('input',  releaseOnce, { once:true });
        idInput.addEventListener('change', releaseOnce, { once:true });
      }
    })();

    // If already selected or single-variant, release immediately; else hard timeout
    if (isSingleVariantProduct() || hasInitialVariantSelected()){
      releaseOnce();
    } else {
      setTimeout(releaseOnce, 900);
    }
    // --- GLOBAL no-flash end ---

    // limited retries (~2s) for search-only apply()
    var n = 0, max = 25;
    var iv = setInterval(function(){
      apply();
      if (++n >= max || window.__WC_USER_PICKED) clearInterval(iv);
    }, 80);

    // observe only the form subtree
    var form = q('form[action*="/cart/add"]', root) || q('product-form form', root);
    var mo = form ? new MutationObserver(function(){ schedule(); }) : null;
    if (mo) mo.observe(form, {subtree:true, childList:true, attributes:true, attributeFilter:['value','checked','selected','name','style']});

    function stop(){ try{ mo && mo.disconnect(); }catch(_){ } }

    // first real user interaction → stop search-only enforcement
    root.addEventListener('change', function(){ window.__WC_USER_PICKED = true; stop(); }, true);
    root.addEventListener('input',  function(){ window.__WC_USER_PICKED = true; stop(); }, true);

    // first pass
    apply();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') start();
  else document.addEventListener('DOMContentLoaded', start, {once:true});

})();



/* ==========================================
WC — PDP gesture decider: allow vertical by default, switch to pan-x on horizontal drag
   ========================================== */
(() => {
  if (!document.querySelector('.template-product')) return;

  const SELECTOR = [
    '.media-gallery .scroll-slider__slider',
    '.product__media-item',
    '.product__media'
  ].join(',');

  let startX = 0, startY = 0, decided = false, el = null;

  const setTA = (node, val) => node?.style.setProperty('touch-action', val, 'important');
  const reset = () => { if (el) el.style.removeProperty('touch-action'); el = null; decided = false; };

  document.addEventListener('pointerdown', (e) => {
    const t = e.target.closest(SELECTOR);
    if (!t || !e.isPrimary) return;
    el = t; decided = false;
    startX = e.clientX; startY = e.clientY;
    setTA(el, 'auto');
  }, { passive: true });

  document.addEventListener('pointermove', (e) => {
    if (!el || decided) return;
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;
    if (Math.abs(dx) + Math.abs(dy) < 6) return;
    decided = true;
    setTA(el, Math.abs(dx) > Math.abs(dy) ? 'pan-x' : 'pan-y');
  }, { passive: true });

  document.addEventListener('pointerup', reset, { passive: true });
  document.addEventListener('pointercancel', reset, { passive: true });
})();

